import { getAuth } from "firebase/auth";

interface FetchOptions extends RequestInit {
  headers?: HeadersInit;
}

const setupInterceptor = async (
  url: string,
  user: any,
  setUser: (user: any) => void,
  options: FetchOptions = {}
): Promise<Response> => {
  const auth = getAuth();
  const user2 = auth.currentUser;
  if (user2) {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${user.accessToken}`,
    };  
  }
  
  let response = await fetch(url, options);

  if ((response.status === 401 || response.status === 403) && user2) {
    try {
      const newToken = await user2.getIdToken(true); 
      // Actualizar el contexto con el nuevo token
      const updatedUser = { ...user, accessToken: newToken };
      setUser(updatedUser);
      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${newToken}`,
      };
      response = await fetch(url, options);
    } catch (error) {
      console.error("Error al renovar el token:", error);
      throw error;
    }
  }

  return response;
};

export default setupInterceptor;
